import * as Immutable from "immutable";
import Parameter from "views/logic/parameters/Parameter";
const _LookupTableParameter = class _LookupTableParameter extends Parameter {
  constructor(name, title, description, dataType, defaultValue, optional, lookupTable, key) {
    super(_LookupTableParameter.type, name, title, description, dataType, defaultValue, optional);
    this._value2 = { lookupTable, key };
  }
  static create(_type, name, title, description, dataType, defaultValue, optional, lookupTable, key) {
    return new _LookupTableParameter(name, title, description, dataType, defaultValue, optional, lookupTable, key);
  }
  toBuilder() {
    const { type, name, title, description, dataType, defaultValue, optional } = this._value;
    const { lookupTable, key } = this._value2;
    return new Builder(
      Immutable.Map({
        type,
        name,
        title,
        description,
        dataType,
        defaultValue,
        optional,
        lookupTable,
        key
      })
    );
  }
  // screw you eslint, using param.constructor.needsBinding() is ugly
  // eslint-disable-next-line class-methods-use-this
  get needsBinding() {
    return false;
  }
  get lookupTable() {
    return this._value2.lookupTable;
  }
  get key() {
    return this._value2.key;
  }
  toJSON() {
    const { type, name, title, description, dataType, defaultValue, optional } = this._value;
    const { lookupTable, key } = this._value2;
    return {
      type,
      name,
      title,
      description,
      data_type: dataType,
      default_value: defaultValue,
      optional,
      binding: void 0,
      lookup_table: lookupTable,
      key
    };
  }
  // static fromJSON(json: LookupTableParameterJson): Parameter {
  static fromJSON(json) {
    const { name, title, description, data_type, default_value, optional, lookup_table, key } = json;
    return new _LookupTableParameter(name, title, description, data_type, default_value, optional, lookup_table, key);
  }
  static builder() {
    return new Builder().type(_LookupTableParameter.type).optional(false).dataType("any");
  }
};
_LookupTableParameter.type = "lut-parameter-v1";
let LookupTableParameter = _LookupTableParameter;
export {
  LookupTableParameter as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  dataType(value) {
    return new Builder(this.value.set("dataType", value));
  }
  defaultValue(value) {
    return new Builder(this.value.set("defaultValue", value));
  }
  optional(value) {
    return new Builder(this.value.set("optional", value));
  }
  lookupTable(value) {
    return new Builder(this.value.set("lookupTable", value));
  }
  key(value) {
    return new Builder(this.value.set("key", value));
  }
  build() {
    const { name, title, description, dataType, defaultValue, optional, lookupTable, key } = this.value.toObject();
    return new LookupTableParameter(name, title, description, dataType, defaultValue, optional, lookupTable, key);
  }
}
LookupTableParameter.Builder = Builder;
